import React, { useRef, useEffect } from "react"

// Adding this element at the end of a list of items ensures that the view is scrolled to there.
// https://stackoverflow.com/a/61266099
const AlwaysScrollToBottom = () => {
  const elementRef = useRef()
  // Block body (not an implicit-return expression) so this effect always returns undefined.
  // Edge appears to return a non-function value from scrollIntoView() in some contexts,
  // which React then tries to invoke as a cleanup and throws "destroy is not a function".
  useEffect(() => {
    elementRef.current && elementRef.current.scrollIntoView()
  })
  return <div ref={elementRef} />
}

export default AlwaysScrollToBottom
